// Composable para gestión de datos de satélite con Composition API (Vue 2.7+)
import { ref, computed } from 'vue'
import axios from '../plugins/axios'
import moment from 'moment'

export function useSatellite(satelliteName) {
  const satellite = ref(null)
  const packets = ref(null)
  const customTemplates = ref(null)
  const satvisFullScreen = ref(false)
  const viewerHost = process.env.VUE_APP_VIEWER_HOST

  const getSatellite = async () => {
    const { data } = await axios.get(`/v1/satellite/${satelliteName}`)
    satellite.value = data
    document.title = `${satellite.value.displayName} satellite - TinyGS`
  }

  const getPackets = async () => {
    const { data } = await axios.get(`/v2/packets?satellite=${satelliteName}`)
    customTemplates.value = data.templates
    packets.value = data.packets
  }

  const formatLaunchDate = (date) => moment(date).format('lll')

  const lastTelemetry = computed(() => {
    if (satellite.value && satellite.value.lastTelemetry)
      return { parsed: satellite.value.lastTelemetry }
    return null
  })

  return {
    satellite,
    packets,
    customTemplates,
    satvisFullScreen,
    viewerHost,
    getSatellite,
    getPackets,
    formatLaunchDate,
    lastTelemetry
  }
}

function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export function processStationStatistics(data, selectedSatellites = []) {
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  const timeWindow = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
  const startTime = today.getTime() - timeWindow;

  const statsByDay = new Map(data.map(s => [s.day, s.frames]));
  const dailySatelliteFrames = {};
  const allSatellites = new Set();

  const labels = [];
  const timestamps = [];

  for (let currDay = startTime; currDay <= today.getTime(); currDay += 24 * 60 * 60 * 1000) {
      timestamps.push(currDay);
      labels.push(new Date(currDay).getDate());

      dailySatelliteFrames[currDay] = {};

      const frames = statsByDay.get(currDay) || [];
      frames.forEach(frame => {
          if (frame.satellite) {
              allSatellites.add(frame.satellite);
              dailySatelliteFrames[currDay][frame.satellite] = (dailySatelliteFrames[currDay][frame.satellite] || 0) + 1;
          }
      });
  }
  
  const satelliteOptions = Array.from(allSatellites).sort();

  const satellitesToDisplay = selectedSatellites.length > 0 ? selectedSatellites : satelliteOptions;

  const datasets = satellitesToDisplay.map(sat => {
      const satData = timestamps.map(ts => {
          return dailySatelliteFrames[ts] && dailySatelliteFrames[ts][sat] ? dailySatelliteFrames[ts][sat] : 0;
      });
      return {
          label: sat,
          data: satData,
          backgroundColor: getRandomColor(),
          stack: 'packets'
      };
  });

  const chartData = {
      labels: labels,
      datasets: datasets
  };

  return {
    chartData,
    satelliteOptions
  }
}